

































































































































































import { Component, Vue, Prop, PropSync } from "vue-property-decorator";
import store from "@/store";
// types
import { CustomExpressionData, ICustomExpressionItem } from "@/types/CustomExpressionData";
import { ExtendedVessel } from "@/types/vessel";
// components
import CustomExpressionsDialog from "@/components/Notifications/CustomExpressionsDialog.vue";
//  modules
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";

const Vessels = getModule(VesselsModule, store);

@Component({
  components: {
    CustomExpressionsDialog,
  },
})
export default class CustomExpressionItem extends Vue {
  @PropSync("expression", { required: true }) syncExpression!: ICustomExpressionItem;
  @Prop({ default: false }) isOperatorSelectAvailable!: boolean;

  // @Data
  CustomExpressionsDialog = false;
  CommentDialog = false;
  CustomExpressionItem!: ICustomExpressionItem;
  comment: string | null = null;

  // @Getters
  get isExpressionValid(): boolean {
    return this.syncExpression.expressions.every(exp => exp.logVariable != null);
  }

  get hasExpressionList(): boolean {
    return this.syncExpression.expressions.length > 0;
  }

  get extendedVesselById(): ExtendedVessel | undefined {
    if (!this.syncExpression) return;
    return Vessels.getExtendedVesselById(this.syncExpression.vesselId);
  }

  get operatorRequired(): boolean {
    return Boolean(this.syncExpression.expressions.length);
  }

  get isCommentDisabled(): boolean {
    return this.syncExpression.expressions.length === 0;
  }

  // @Methods
  onEditExpression(): void {
    this.CustomExpressionItem = JSON.parse(JSON.stringify(this.syncExpression));
    this.CustomExpressionsDialog = true;
  }

  deleteCondition(index: number | undefined): void {
    if (index == null) {
      // deleted LogDataMathExpression and set it to "Logical" type
      this.syncExpression.expressions.splice(0, 1);
      this.syncExpression.expressionType = "Logical";
    } else this.syncExpression.expressions.splice(index, 1);
    this.$emit("onConditionDeleted");
  }

  onTypeChanged(type: string): void {
    Vue.set(this.CustomExpressionItem, "expressionType", type);
    this.CustomExpressionItem.expressions.forEach(e => Vue.set(e, "expressionType", type));
    this.$emit("onTypeChanged", { vesselId: this.syncExpression.vesselId, type: type });
  }

  onSaveCustomExpressions(expressionItemList: ICustomExpressionItem[]): void {
    this.CustomExpressionItem = JSON.parse(JSON.stringify(expressionItemList[0]));
    this.$emit("expressionChanged", this.CustomExpressionItem);
  }

  openCommentDialog(): void {
    this.CommentDialog = true;
  }

  closeCommentDialog(): void {
    this.CommentDialog = false;
    this.comment = this.syncExpression.comment;
  }

  saveComment(): void {
    Vue.set(this.syncExpression, "comment", this.comment);
    this.CommentDialog = false;
    this.$emit("onComment", { vesselId: this.syncExpression.vesselId, comment: this.syncExpression.comment });
  }

  logVariableName(expressionItem: CustomExpressionData): string | undefined {
    return expressionItem?.logVariable?.name;
  }

  logVariableUnitName(expressionItem: CustomExpressionData): string {
    if (!expressionItem.logVariable?.unit.name) return "";
    return expressionItem.logVariable?.unit.name;
  }

  created(): void {
    this.CustomExpressionItem = {
      vesselId: this.syncExpression.vesselId,
      vesselName: this.syncExpression.vesselName,
      expressions: this.syncExpression.expressions ? this.syncExpression.expressions : [],
      expressionType: this.syncExpression.expressionType,
      comment: null,
    };
    this.comment = this.syncExpression.comment;
  }
}
